import React, { createContext, useContext, useEffect, useState } from "react";

const ThemeContext = createContext({ theme: "dark", toggle: () => {} });

const apply = (theme) => {
  const root = document.documentElement;
  root.classList.remove("dark", "light");
  root.classList.add(theme);
};

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(() => {
    try {
      return localStorage.getItem("bagfluence-theme") || "dark";
    } catch (e) {
      console.warn("Theme: localStorage read failed", e);
      return "dark";
    }
  });

  useEffect(() => {
    apply(theme);
    try {
      localStorage.setItem("bagfluence-theme", theme);
    } catch (e) {
      console.warn("Theme: localStorage write failed", e);
    }
  }, [theme]);

  const toggle = () => setTheme((t) => (t === "dark" ? "light" : "dark"));

  return (
    <ThemeContext.Provider value={{ theme, toggle, setTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);
